import {
  AgenciesPermission,
  AvailabilityPermission,
  ClientConfigPermission,
  ClientsPermission,
  CompaniesPermission,
  CountriesPermission,
  DeliveriesPermission,
  NegotiationsPermission,
  Permission,
  ProfessionsPermission,
  ProjectsPermission,
  PropertiesPermission,
  RepresentantsPermission,
  RolesPermission,
  SocietiesPermission,
  StatesPermission,
  StateTransitionPermission,
  TypePropertiesPermission,
  type typePermission,
  UsersPermission,
  WorkflowsPermission
} from '@idc-forms/permissions'
import { SEGMENTS } from '@/app/router/routes'

// Re-export all shared permissions — source of truth is @idc-forms/permissions
export {
  AgenciesPermission,
  AvailabilityPermission,
  ClientConfigPermission,
  ClientsPermission,
  CompaniesPermission,
  CountriesPermission,
  DeliveriesPermission,
  NegotiationsPermission,
  Permission,
  ProfessionsPermission,
  ProjectsPermission,
  PropertiesPermission,
  RepresentantsPermission,
  RolesPermission,
  SocietiesPermission,
  StatesPermission,
  StateTransitionPermission,
  TypePropertiesPermission,
  type typePermission,
  UsersPermission,
  WorkflowsPermission
}

// FE-only: business permissions group (without client-specific permissions)
export const PermissionBusiness = {
  ...RolesPermission,
  ...UsersPermission,
  ...CompaniesPermission,
  ...AgenciesPermission,
  ...RepresentantsPermission,
  ...CountriesPermission,
  ...StatesPermission,
  ...StateTransitionPermission,
  ...WorkflowsPermission,
  ...ProfessionsPermission,
  ...SocietiesPermission,
  ...ProjectsPermission,
  ...PropertiesPermission,
  ...TypePropertiesPermission,
  ...NegotiationsPermission,
  ...DeliveriesPermission,
  ...ClientConfigPermission
}

// FE-only: maps permission values to their admin routes
export const PermissionBusinessAndRoute = {
  [UsersPermission.CreateUsers]: SEGMENTS.business.users,
  [UsersPermission.ReadUsers]: SEGMENTS.business.users,
  [UsersPermission.UpdateUsers]: SEGMENTS.business.users,
  [UsersPermission.DeleteUsers]: SEGMENTS.business.users,
  [RolesPermission.CreateRoles]: SEGMENTS.business.roles,
  [RolesPermission.ReadRoles]: SEGMENTS.business.roles,
  [RolesPermission.UpdateRoles]: SEGMENTS.business.roles,
  [RolesPermission.DeleteRoles]: SEGMENTS.business.roles,
  [CompaniesPermission.CreateCompanies]: SEGMENTS.business.companies,
  [CompaniesPermission.ReadCompanies]: SEGMENTS.business.companies,
  [CompaniesPermission.UpdateCompanies]: SEGMENTS.business.companies,
  [CompaniesPermission.DeleteCompanies]: SEGMENTS.business.companies,
  [AgenciesPermission.CreateAgencies]: SEGMENTS.business.agencies,
  [AgenciesPermission.ReadAgencies]: SEGMENTS.business.agencies,
  [AgenciesPermission.UpdateAgencies]: SEGMENTS.business.agencies,
  [AgenciesPermission.DeleteAgencies]: SEGMENTS.business.agencies,
  [RepresentantsPermission.CreateRepresentants]: SEGMENTS.business.representants,
  [RepresentantsPermission.ReadRepresentants]: SEGMENTS.business.representants,
  [RepresentantsPermission.UpdateRepresentants]: SEGMENTS.business.representants,
  [RepresentantsPermission.DeleteRepresentants]: SEGMENTS.business.representants,
  [CountriesPermission.CreateCountries]: SEGMENTS.business.countries,
  [CountriesPermission.ReadCountries]: SEGMENTS.business.countries,
  [CountriesPermission.UpdateCountries]: SEGMENTS.business.countries,
  [CountriesPermission.DeleteCountries]: SEGMENTS.business.countries,
  [StatesPermission.CreateStates]: SEGMENTS.business.states,
  [StatesPermission.ReadStates]: SEGMENTS.business.states,
  [StatesPermission.UpdateStates]: SEGMENTS.business.states,
  [StatesPermission.DeleteStates]: SEGMENTS.business.states,
  [WorkflowsPermission.CreateWorkflows]: SEGMENTS.business.workflows,
  [WorkflowsPermission.ReadWorkflows]: SEGMENTS.business.workflows,
  [WorkflowsPermission.UpdateWorkflows]: SEGMENTS.business.workflows,
  [WorkflowsPermission.DeleteWorkflows]: SEGMENTS.business.workflows,
  [ProfessionsPermission.CreateProfessions]: SEGMENTS.business.professions,
  [ProfessionsPermission.ReadProfessions]: SEGMENTS.business.professions,
  [ProfessionsPermission.UpdateProfessions]: SEGMENTS.business.professions,
  [ProfessionsPermission.DeleteProfessions]: SEGMENTS.business.professions,
  [SocietiesPermission.CreateSocieties]: SEGMENTS.business.societies,
  [SocietiesPermission.ReadSocieties]: SEGMENTS.business.societies,
  [SocietiesPermission.UpdateSocieties]: SEGMENTS.business.societies,
  [SocietiesPermission.DeleteSocieties]: SEGMENTS.business.societies,
  [ProjectsPermission.CreateProjects]: SEGMENTS.business.projects,
  [ProjectsPermission.ReadProjects]: SEGMENTS.business.projects,
  [ProjectsPermission.UpdateProjects]: SEGMENTS.business.projects,
  [ProjectsPermission.DeleteProjects]: SEGMENTS.business.projects,
  [PropertiesPermission.CreateProperties]: SEGMENTS.business.properties,
  [PropertiesPermission.ReadProperties]: SEGMENTS.business.properties,
  [PropertiesPermission.UpdateProperties]: SEGMENTS.business.properties,
  [PropertiesPermission.DeleteProperties]: SEGMENTS.business.properties,
  [TypePropertiesPermission.CreateTypeProperties]: SEGMENTS.business.typeProperties,
  [TypePropertiesPermission.ReadTypeProperties]: SEGMENTS.business.typeProperties,
  [TypePropertiesPermission.UpdateTypeProperties]: SEGMENTS.business.typeProperties,
  [TypePropertiesPermission.DeleteTypeProperties]: SEGMENTS.business.typeProperties,
  [ClientConfigPermission.ReadClientConfig]: SEGMENTS.business.clientConfig,
  [ClientConfigPermission.UpdateClientConfig]: SEGMENTS.business.clientConfig
}
